/**
 * Les lignes du test du matériel (`UIDeviceCheckLine`), lues par la bande de l'entrée du live
 * (`<LiveLobbyDeviceStrip>`) et par son view-model.
 */
import { type UIDeviceCheckLine } from "../types/studentDeviceCheck"

/** Une ligne qui demande l'attention : passée, ou d'un verdict moyen ou mauvais. */
export function deviceCheckLineFailing(line: UIDeviceCheckLine): boolean {
    return line.skipped === true || line.verdict === "bad" || line.verdict === "warn"
}
